const al = {
 "studio": "Resource Studio",
 "studioSub": "Find → Preview → Adapt → Assign. Preview set: {n} resources.",
 "search": "Search resources",
 "all": "All",
 "language": "Language",
 "level": "Level",
 "type": "Type",
 "eligibility": "Available in",
 "why": "Why this fits",
 "reg": {"label": "Register", "unspecified": "Not specified", "v": {"formal": "Formal", "informal": "Informal", "mixed": "Mixed", "neutral_na": "Neutral / not applicable"}, "edit": "Edit", "choose": "Choose register", "notePh": "Optional short note", "notePhMixed": "Who uses which form? (required for mixed)", "noteNeeded": "Mixed register needs a short note.", "saved": "Register saved. Activity text unchanged."},
 "teacherOnly": "Teacher only",
 "answerKey": "Answer key",
 "rubric": "Rubric",
 "notes": "Teacher notes",
 "preview": "Student preview",
 "adapt": "Adapt",
 "assign": "Assign to class",
 "assigned": "Assigned to your class.",
 "adapted": "Your adapted copy was saved. The original is unchanged.",
 "titleLabel": "Title",
 "instructionsLabel": "Student instructions",
 "save": "Save copy",
 "cancel": "Cancel",
 "noResults": "No resources match these filters.",
 "previewNote": "Preview test content — not part of the future production library",
 "lab": "Discovery Lab",
 "labSub": "Discover → try → understand → use. A few small activities to explore.",
 "secTry": "Try this",
 "secPattern": "Explore a pattern",
 "secSolve": "Solve something",
 "secRead": "Read & discover",
 "check": "Check",
 "score": "{c} of {t} correct",
 "tryAgain": "Try again",
 "done": "Done",
 "know": "Know",
 "again": "Again",
 "flip": "Tap to flip",
 "keep": "Keep these for my personal practice",
 "kept": "Saved to your Vocab Bank.",
 "cantKeep": "This set's language isn't one of your learning languages, so it can't be saved.",
 "practiceDone": "Practice saved for your class.",
 "results": "Class results",
 "completed": "Completed",
 "attempted": "Started",
 "notAttempted": "Not started",
 "classResources": "Class resources",
 "open": "Open",
 "minutes": "{n} min",
 "failed": "Something went wrong. Please try again.",
 "close": "Close",
 "cardOf": "{i} / {n}",
 "pickClass": "Choose a class",
 "mine": "My adaptations",
 "explored": "Explored",
 "fam": {
  "grammar": "Grammar",
  "worksheet": "Worksheet",
  "memory": "Flashcards",
  "game": "Puzzle",
  "form": "Form",
  "document": "Real-world document",
  "speaking": "Speaking",
  "reading": "Reading & culture",
  "assessment": "Assessment",
  "data": "Data challenge"
 },
 "elig": {
  "public": "Public",
  "pro": "Pro",
  "education": "Education"
 }
};
al.p = {
 "sev": {"low": "Low", "medium": "Medium", "high": "High"},
 "area": {"language_accuracy": "Language accuracy", "naturalness": "Naturalness", "cefr_fit": "CEFR fit", "answer_key": "Answer key", "instructions": "Instructions", "pedagogy": "Pedagogy", "culture_stereotypes": "Culture & stereotypes", "duplication": "Duplication", "formatting_script": "Formatting & script", "provenance": "Provenance", "objective_alignment": "Objective alignment", "teacher_learner_match": "Teacher/learner match"},
 "edited": "edited",
 "precheck": "AI pre-check",
 "precheckRun": "Run AI pre-check",
 "precheckRerun": "Run again",
 "precheckNone": "No pre-check yet.",
 "precheckStale": "older version",
 "corrections": "{n} proposed corrections (not applied)",
 "precheckAdvisory": "Advisory only. It never approves or changes the asset.",
 "pv": {"pass": "AI: pass", "revise": "AI: revise", "attention": "AI: needs human attention", "ready": "AI: ready for human review", "blocked": "AI: blocking issues"},
 "badJson": "That isn't valid JSON.",
 "contentSaved": "Content saved. The previous version is kept in the log.",
 "editContent": "Edit content",
 "editTrail": "Every change is logged with the previous content.",
 "history": "Versions",
 "startRevision": "Start revision",
 "revisionStarted": "Draft v{v} created. v1 stays live until it's approved.",
 "histAssign": "{n} class assignments keep their frozen versions.",
 "confirmElig": "I reviewed availability: {e}",
 "confirmEligFirst": "Confirm the availability for this asset first.",
 "objective": "Objective",
 "provenance": "Provenance",
 "wave": "Wave filter",
 "booklet": "Lesson booklet",
 "summary": "Summary PDF",
 "showMore": "Show {n} more",
 "showLess": "Show less",
 "checklistIncomplete": "Mark every checklist point first.",
 "across": "Across",
 "down": "Down",
 "clueListNote": "Write each answer next to its number. The number in brackets is the number of letters.",
 "again": "Practise again",
 "exportVersion": "Export version",
 "print": "Print",
 "export": "Export",
 "theme": "Theme",
 "grammar": "Grammar focus",
 "vocab": "Vocabulary focus",
 "function": "Communicative function",
 "duration": "Minutes",
 "teacherInstr": "Instructions for the AI (optional)",
 "canonical": "Canonical GetFluentLoop draft (enters admin review)",
 "draftSaved": "Draft saved. It's private to you until you mark it ready.",
 "draftNote": "AI draft: check language, level and answers before saving.",
 "fromFile": "Created from",
 "saveDraft": "Save draft",
 "uploaded": "File uploaded to your files.",
 "aiNote": "AI drafts always start as private drafts. Nothing is published or assigned automatically.",
 "uploadNote": "Upload a PDF, Word, text, CSV or Excel file. The original stays unchanged; an activity is a separate private draft.",
 "uploadedAs": "saved as a resource.",
 "useAsResource": "Use as resource ✓",
 "orCreate": "or create an activity from it below:",
 "generating": "Generating…",
 "generate": "Generate draft",
 "createFromFile": "Create an activity from this",
 "suggestedBy": "Suggested by a teacher",
 "checklist": "Quality checklist",
 "checklistNote": "Human review. Mark each point; concerns must be resolved before review.",
 "reviewNote": "Review / approval note (internal)",
 "reviewSub": "Editorial queue for canonical GetFluentLoop content. Notes stay internal.",
 "reviewEmpty": "Nothing here.",
 "packName": "Pack name",
 "packCreated": "Pack created.",
 "packsSub": "Packs bundle resources, missions and files. Personal packs stay private unless a school admin shares them.",
 "createPack": "Create pack",
 "packsEmpty": "No packs yet.",
 "school": "School",
 "private": "Private",
 "packSaved": "Saved as a pack.",
 "subSub": "Builds a cover lesson from approved resources only, with no AI generation.",
 "themeOptional": "Theme (optional)",
 "buildLesson": "Build lesson",
 "lessonTotal": "Lesson: {n} min (asked for {r})",
 "mission": "mission",
 "missing": "No approved match yet",
 "subNote": "Print each part from Resource Studio. Answer keys stay teacher-only.",
 "savePack": "Save as pack",
 "linked": "Attached to the mission.",
 "useInMission": "Use in a mission",
 "startMission": "Start a mission draft",
 "orExisting": "or attach to one of your saved missions:",
 "noMissions": "No saved missions in this language.",
 "attach": "Attach",
 "addedToPack": "Added to pack.",
 "choosePack": "Choose a pack",
 "addToPack": "Add to pack",
 "readyDone": "Ready to assign.",
 "markReady": "Mark ready",
 "unshared": "No longer shared.",
 "shared": "Shared with your school.",
 "unshare": "Stop sharing",
 "share": "Share with school",
 "suggest": "Suggest for GetFluentLoop Library",
 "draftPrivate": "Private draft: only you can see it. Mark it ready to assign it.",
 "suggestNote": "This creates a separate review copy for the GetFluentLoop editors. Your version stays exactly as it is.",
 "rights": "Your rights to share this",
 "suggestNotePh": "Anything the editors should know (optional)",
 "suggested": "Sent to the GetFluentLoop review queue.",
 "send": "Send",
 "denied": "Resource Studio is for verified teachers.",
 "draftNoAssign": "Mark it ready before assigning.",
 "schoolShared": "Shared in my school",
 "missionResources": "Resources for this mission",
 "attachResources": "Attach resources (same language)",
 "noCompatible": "No ready resources in this language.",
 "previewCombined": "Preview with resources",
 "pickMissionFor": "Pick a mission to pair with {id} ({lang}), then attach it in the assign step.",
 "ver": {
  "learner": "Learner worksheet",
  "teacher": "Teacher version",
  "answer_key": "Answer key",
  "teacher_guide": "Teacher guide"
 },
 "grp": {
  "individual": "Individual",
  "pairs": "Pairs",
  "groups": "Groups",
  "whole_class": "Whole class"
 },
 "mode": {
  "ai": "AI draft",
  "upload": "From a file"
 },
 "out": {
  "worksheet": "Worksheet",
  "grammar_discovery": "Grammar discovery",
  "flashcards": "Flashcard set",
  "crossword": "Crossword / puzzle",
  "interactive_form": "Interactive form",
  "reading": "Reading",
  "speaking_cards": "Speaking cards",
  "exit_ticket": "Exit ticket",
  "data_challenge": "Data challenge"
 },
 "st": {
  "draft": "Draft",
  "reviewed": "Reviewed",
  "approved": "Approved",
  "retired": "Retired",
  "superseded": "Superseded",
  "teacher_ready": "Ready"
 },
 "cv": {
  "pass": "Pass",
  "concern": "Concern",
  "na": "N/A"
 },
 "do": {
  "reviewed": "Mark reviewed",
  "approved": "Approve",
  "draft": "Send back to draft",
  "retired": "Retire"
 },
 "pp": {
  "warmups": "10-minute warm-ups",
  "speaking": "Speaking week",
  "revision": "Exam revision",
  "reading": "Reading week",
  "grammar": "Grammar discovery",
  "substitute": "Substitute teacher",
  "other": "Other"
 },
 "slot": {
  "starter": "Starter",
  "main": "Main activity",
  "speaking": "Speaking",
  "resource": "Worksheet / resource",
  "exit": "Exit ticket"
 },
 "rt": {
  "own_work": "My own work",
  "cc_by": "CC BY",
  "cc0": "CC0",
  "public_domain": "Public domain",
  "licensed_for_reuse": "Licensed for reuse"
 },
 "tab": {
  "library": "Library",
  "create": "Create",
  "packs": "Packs",
  "substitute": "Substitute pack",
  "review": "Review"
 },
 "ck": {
  "language_correct": "Language correct",
  "cefr_fit": "CEFR level fits",
  "objective_clear": "Clear objective",
  "meaningful_language_use": "Requires meaningful language use",
  "learner_instructions": "Learner instructions clear",
  "teacher_instructions": "Teacher instructions clear",
  "cultural_credibility": "Culturally credible",
  "stereotype_risk": "No stereotypes",
  "age_context": "Suitable for age and context",
  "copyright_provenance": "Copyright / provenance OK",
  "privacy": "No personal data",
  "cards_accurate": "Cards accurate",
  "roles_balanced": "Roles balanced",
  "data_plausible": "Data plausible",
  "answer_key_correct": "Answer key correct",
  "puzzle_solvable": "Puzzle solvable",
  "text_level": "Text at the right level",
  "authentic_format": "Authentic format",
  "realistic_form": "Realistic form"
 }
};
al.ed = {
 "title": "Corrections",
 "note": "AI proposes; you decide each change. The current version is never edited — accepted changes create a new draft version.",
 "propose": "Propose corrections",
 "recheck": "Run AI re-check",
 "proposed": "proposed",
 "applied": "applied",
 "mechanical": "Quick fixes ({n})",
 "editorial": "Editorial changes — decide deliberately ({n})",
 "acceptMech": "Accept all {n} quick fixes",
 "accept": "Accept",
 "reject": "Reject",
 "edit": "Edit",
 "undo": "Undo decision",
 "material": "Changes",
 "quoteMismatch": "AI quote differed; showing the real current text",
 "dropped": "{n} suggestions dropped (not addressable)",
 "pending": "{n} still to decide",
 "apply": "Apply decisions → new draft version",
 "v2made": "Draft v{v} created and sent to AI re-check.",
 "sentAsIs": "No changes accepted — this version goes to the review queue as it is.",
 "attention": "Needs human attention",
 "carried": "From v{v}: {n} AI flags, {r} rejected corrections",
 "changed": "{n} fields changed from the previous version",
 "gotoNext": "Open the newer version",
 "kind": {"mechanical": "quick fix", "editorial": "editorial"},
 "cat": {"language": "Language", "pedagogy_cefr": "Pedagogy / CEFR", "answer_key": "Answer key", "culture_content": "Culture / content", "formatting_technical": "Formatting / technical"},
 "dec": {"pending": "Not decided", "accepted": "Accepted", "rejected": "Rejected", "edited": "Edited"},
 "stage": {"new": "Not started", "corrections": "Deciding corrections", "recheck": "Awaiting AI re-check", "in_review": "In review queue", "superseded": "Replaced by a newer version"},
 "filter": {"all": "All drafts", "to_correct": "To correct", "in_review": "Review queue"}
};
al.ck2 = {
 "tier": {"blocking": "Blocking", "review": "Review", "advisory": "Advisory"},
 "status": {"ready_for_human_review": "AI status: Ready for human review", "blocking_issues_remain": "AI status: Blocking issues remain", "needs_human_attention": "AI status: Needs human attention"},
 "rule": "rule check",
 "carried": "carried",
 "new": "new",
 "resolved": "Resolved",
 "scanned": "{n} drafts scanned",
 "incons": "Reviewer inconsistency — the AI contradicted its own earlier recommendation. Your judgment:",
 "summaryNotReady": "Not re-checked with the calibrated reviewer yet",
 "blockerRound": "Propose blocker-only fixes (final round)",
 "ceiling": "Revision ceiling reached (v3). You decide what happens next.",
 "wave": "Wave rules (dry run)",
 "wavePreview": "Preview wave rules",
 "waveNote": "Preview only — nothing is changed or versioned.",
 "affected": "{n} drafts affected",
 "det": "deterministic",
 "interp": "needs interpretation",
 "overlap": "{n} drafts would get more than one rule"
};
export default al;
